import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  getNavigationState,
  primaryNavigation,
} from "../navigation";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() =>
    window.matchMedia("(max-width: 768px)").matches,
  );
  const menuButtonRef = useRef(null);
  const navigationRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const mobileQuery = window.matchMedia("(max-width: 768px)");
    const handleViewportChange = (event) => {
      setIsMobile(event.matches);
      if (!event.matches) setIsMenuOpen(false);
    };

    mobileQuery.addEventListener("change", handleViewportChange);
    return () => mobileQuery.removeEventListener("change", handleViewportChange);
  }, []);

  useEffect(() => {
    if (!isMobile || !isMenuOpen) return undefined;

    const focusFirstLink = window.requestAnimationFrame(() => {
      navigationRef.current?.querySelector("a")?.focus();
    });
    const handleKeyDown = (event) => {
      if (event.key !== "Escape") return;
      event.preventDefault();
      setIsMenuOpen(false);
      window.requestAnimationFrame(() => menuButtonRef.current?.focus());
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.cancelAnimationFrame(focusFirstLink);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isMenuOpen, isMobile]);

  const toggleMenu = () => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
      window.requestAnimationFrame(() => menuButtonRef.current?.focus());
      return;
    }

    setIsMenuOpen(true);
  };
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="header">
      <div className="header__primary">
        <div className="container header-container">
          <div className="logo">
            <Link to="/" onClick={closeMenu}>
              Magued Hanna
            </Link>
          </div>

          <button
            className={`mobile-menu-btn ${isMenuOpen ? "open" : ""}`}
            onClick={toggleMenu}
            aria-expanded={isMenuOpen}
            aria-controls="primary-navigation"
            aria-label={`${isMenuOpen ? "Close" : "Open"} navigation menu`}
            ref={menuButtonRef}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <nav
            className={`nav-menu ${isMenuOpen ? "active" : ""}`}
            id="primary-navigation"
            aria-label="Primary navigation"
            aria-hidden={isMobile && !isMenuOpen ? "true" : undefined}
            inert={isMobile && !isMenuOpen}
            ref={navigationRef}
          >
            <ul>
              {primaryNavigation.map((item) => {
                const { isActive, isCurrent } = getNavigationState(
                  location.pathname,
                  item,
                );

                return (
                  <li key={item.to}>
                    <Link
                      to={item.to}
                      className={`nav-link${isActive ? " active" : ""}`}
                      aria-current={isCurrent ? "page" : undefined}
                      onClick={closeMenu}
                    >
                      {item.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
